import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { coachingCallAllowanceSelector } from '@src/screens/NutritionistHub/models/nutritionistHub.selectors'

export const useCoachingCallAllowanceBalance = () => {
  const coachingCallAllowance = useSelector(coachingCallAllowanceSelector)

  return useMemo(() => {
    const totalCredits = coachingCallAllowance?.total ?? 0
    const remainingCredits = coachingCallAllowance?.remaining ?? 0
    const allocatedCredits = coachingCallAllowance?.allocated ?? 0
    const availableCredits = Math.max(remainingCredits - allocatedCredits, 0)
    const hasAllowanceBalance = totalCredits > 0

    return {
      availableCredits,
      hasAllowanceBalance,
    }
  }, [coachingCallAllowance])
}
